import { useNavigate } from "react-router-dom";
import myrisIcon from '../../../assets/myris-tech-icon.png';
import instagramIcon from '../../../assets/instagram-icon.png';
import './HomeFooterContainer.css'

const HomeFooterContainer = () => {
  const navigate = useNavigate();
  
  return (
    <div className='footer-component'>
      <div className='left-components'>
        <img src={myrisIcon} alt="myris-technology" style={{ height: '50px', filter: 'invert(1)' }} /> {/** may possibly remove here depending on what looks better */}
        <h1>MYRIS TECH @ 2025</h1>
      </div>
      <div className='right-components'>
        <div className='left-components'>
          <div onClick={() => navigate("/about")} style={{ cursor: 'pointer' }}>
            <h1 style={{margin: 20}}>About</h1>
          </div>
          <div onClick={() => navigate("/founders")} style={{ cursor: 'pointer' }}>
            <h1 style={{margin: 20}}>Founders</h1>
          </div>
          <div onClick={() => navigate("/contact")} style={{ cursor: 'pointer' }}>
            <h1 style={{margin: 20}}>Contact</h1>
          </div>
        </div>
        <div className='right-components'>
          <div onClick={() => window.open('https://www.myris-tech.com/', '_blank', 'noopener,noreferrer')}>
            <img src={instagramIcon} alt="instagram" style={{ cursor: 'pointer', height: '50px', filter: 'invert(1)' }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeFooterContainer;